import React, { useState } from 'react';
import './VideoFacade.scss';

const VideoFacade = ({ src, title = 'Video Player', className = '', customPoster = null }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  // Helper to extract YouTube Video ID
  const getYouTubeId = (url) => {
    if (!url) return null;
    const match = url.match(/(?:embed\/|v\/|watch\?v=|youtu\.be\/|\/v\/|^)([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : null;
  };



  const youtubeId = getYouTubeId(src);

  // Derive poster thumbnail
  let posterUrl = customPoster;
  if (!posterUrl) {
    if (youtubeId) {
      posterUrl = `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`;
    }
  }

  // Generate autoplay URL when activated
  const getAutoplayUrl = () => {
    if (!src) return '';
    const separator = src.includes('?') ? '&' : '?';
    return `${src}${separator}autoplay=1`;
  };

  const handlePlay = () => {
    setIsPlaying(true);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handlePlay();
    }
  };

  return (
    <div className={`videoFacadeContainer ${className}`}>
      {isPlaying ? (
        <iframe
          className="videoIframe"
          title={title}
          src={getAutoplayUrl()}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <div
          className="videoFacadePoster"
          role="button"
          tabIndex={0}
          aria-label={`Play ${title}`}
          onClick={handlePlay}
          onKeyDown={handleKeyDown}
        >
          {posterUrl ? (
            <img
              src={posterUrl}
              alt={title}
              className="facadeImage"
              loading="lazy"
            />
          ) : (
            <div className="facadeFallbackBackground">
              <span className="facadeLabel">{title}</span>
            </div>
          )}

          <div className="playButtonOverlay">
            <div className="playButtonCircle">
              <svg
                viewBox="0 0 24 24"
                className="playIcon"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M8 5v14l11-7z" fill="currentColor" />
              </svg>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoFacade;
